export default {
  DOSSIERDATA: "dossierdata",
  ONLINE_AFSPRAKEN: "online_afspraken",
};
